import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.error) toast.error(location.state.error);
  }, [location.state]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] px-6 text-white">
      <div className="w-full max-w-md border border-white/10 bg-[#101010] p-8 md:p-10" data-testid="admin-login">
        <div className="mb-6 flex items-center gap-3">
          <img src="/trainova-logo.png" alt="Trainova" className="h-10 w-10 rounded-sm object-cover" />
          <span className="font-condensed text-2xl tracking-widest">TRAINOVA</span>
        </div>
        <div className="mb-2 flex items-center gap-2 text-teal">
          <Lock size={16} />
          <span className="font-condensed text-sm tracking-[0.35em]">ADMIN ACCESS</span>
        </div>
        <h1 className="font-display text-4xl uppercase leading-none md:text-5xl">Dashboard login</h1>
        <p className="mt-4 text-zinc-400">
          Sign in with the authorized Google account to view waitlist and contact submissions.
        </p>
        <button
          onClick={login}
          data-testid="admin-google-login-btn"
          className="mt-8 flex w-full items-center justify-center gap-3 bg-white px-6 py-4 font-bold uppercase tracking-wide text-black transition-transform duration-200 hover:scale-[1.02]"
        >
          <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
          </svg>
          Sign in with Google
        </button>
        <a href="/" className="mt-6 block text-center text-sm text-zinc-500 transition-colors hover:text-teal">
          ← Back to site
        </a>
      </div>
    </div>
  );
}
